import { configureStore } from '@reduxjs/toolkit';
import authSlice, { logout, setTokens } from './authSlice';
import { setupAuthInterceptor } from './config';
import signup from './signup';
import forgetPasswordSlice from './forgetPasswordSlice';
import claimsSlice from './claimsSlice';
import companySlice from './companySlice';
import notificationSlice from './notificationSlice';
import countrySlice from './countrySlice';
import organizationSlice from './organizationSlice';

export const store = configureStore({
  reducer: {
    notifications: notificationSlice,
    client: authSlice,
    signup: signup,
    forgotPassword: forgetPasswordSlice,
    claims: claimsSlice,
    company: companySlice,
    country: countrySlice,
    organization: organizationSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

setupAuthInterceptor({
  onRefreshed: (tokens) => store.dispatch(setTokens(tokens)),
  onFailed: () => store.dispatch(logout())
});
